import { Box, Grid2, Paper, Stack, Typography } from "@mui/material";
import React from "react";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useSearchParams } from "react-router";
export default function LeftSection() {
  const [searchParams] = useSearchParams();
  const userParam = searchParams.get("user");
  // StepItem component for rendering each step with an icon
  const StepItem = ({ step, description }) => {
    return (
      <Box sx={{ display: "flex", alignItems: "center", marginBottom: 2 }}>
        <CheckCircleOutlineIcon sx={{ color: "#fafafa", marginRight: 1 }} />
        <Typography variant="body1">
          Step {step}: {description}
        </Typography>
      </Box>
    );
  };
  return (
    <Grid2
      size={{ xs: 12, md: 3 }}
      sx={{
        display: "flex",
        flexDirection: "column",
        padding: 2,
      }}
    >
      <Paper
        elevation={3}
        sx={{
          background: (theme) => theme.palette.primary.main,
          height: "100%",
          paddingY: { xs: 2, md: 4 },
          paddingX: 2,
          borderRadius: 4,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          color: "#fafafa",
          justifyContent: { xs: "center", md: "start" },
        }}
      >
        <img src="/logo_plain.png" width={"80%"} alt="logo" />
        <Typography variant="h4" mt={{ xs: 2, md: 6 }} textAlign="center">
          {userParam
            ? "Therapist's Patient Intake Form"
            : "Patient Intake Form"}
        </Typography>
        {/* Step description section */}
        <Stack mt={4} display={{ xs: "none", md: "flex" }}>
          <Typography variant="h6" mb={2} fontWeight={400}>
            Please complete the following steps
          </Typography>
          <StepItem step={1} description="Personal Info" />
          <StepItem step={2} description="Program Details" />
          {!userParam && <StepItem step={3} description="Receipt Details" />}
        </Stack>
        {!userParam && (
          <Typography
            variant="body2"
            mt={2}
            sx={{
              backgroundColor: "rgba(255,255,255,0.2)",
              paddingY: 1.5,
              paddingX: 1.5,
              borderRadius: "8px",
              border: "1px solid #1b8b7f",
            }}
          >
            If you would like to register an another patient under the same
            device, please drop us a WhatsApp message at +92 343 9309980.
          </Typography>
        )}
      </Paper>
    </Grid2>
  );
}
